import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UtmParams {
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_term?: string | null;
  fbclid?: string | null;
}

export interface UtmState {
  utmParams: UtmParams;
}

export const utmState: UtmState = {
  utmParams: {},
};

export const utmSlice = createSlice({
  name: 'utm',
  initialState: utmState,
  reducers: {
    setUtmParams: (draft, action: PayloadAction<UtmParams>) => {
      draft.utmParams = action.payload;
    },
    clearUtmParams: (draft) => {
      draft.utmParams = {};
    },
  },
});

export const { setUtmParams, clearUtmParams } = utmSlice.actions;

export default utmSlice.reducer;
